import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { useAuth } from '../../hooks/useAuth';
import Modal from '../common/Modal';
import Input from '../common/Input';
import Button from '../common/Button';
import Select from '../common/Select';

const CreateProject = ({ onClose, onProjectCreated }) => {
  const { userProfile } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    key: '',
    emoji: '📁'
  });

  const emojiOptions = [
    { value: '📁', label: '📁 Folder' },
    { value: '🚀', label: '🚀 Rocket' },
    { value: '💻', label: '💻 Computer' },
    { value: '📱', label: '📱 Mobile' },
    { value: '🌐', label: '🌐 Web' },
    { value: '🔧', label: '🔧 Tool' },
    { value: '📊', label: '📊 Chart' },
    { value: '🎯', label: '🎯 Target' },
  ];

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.key) {
      alert('Please fill in all required fields');
      return;
    }

    try {
      setLoading(true);
      
      const projectData = {
        ...formData,
        key: formData.key.toUpperCase(),
        members: [userProfile.uid],
        createdBy: userProfile.uid,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };

      const docRef = await addDoc(collection(db, 'projects'), projectData);
      
      onProjectCreated({
        id: docRef.id,
        ...projectData
      });
    } catch (error) {
      console.error('Error creating project:', error);
      alert('Failed to create project');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Create New Project"
      onClose={onClose}
      size="medium"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          label="Project Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Enter project name"
          required
        />
        
        <Input
          label="Project Key"
          name="key"
          value={formData.key}
          onChange={handleChange}
          placeholder="e.g., JIRA"
          maxLength={10}
          required
        />
        
        <Input
          label="Description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          placeholder="Enter project description"
          required
        />
        
        <Select
          label="Project Icon"
          name="emoji"
          value={formData.emoji}
          onChange={handleChange}
          options={emojiOptions}
        />

        <div className="flex justify-end space-x-3 pt-4">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            loading={loading}
          >
            Create Project
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default CreateProject;